import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  deleteIcon: {
    color: '#ee6d59',
  },
  editIcon: {
    color: '#636dde',
  },
});
